export default __webpack_public_path__ + "static/media/dots.981901d1.svg";